import { useOrderStatusLabel } from 'hooks/business/chat/useOrder';

export const Status = ({ tradeStatus }: { tradeStatus?: Conversation.Trade.Status }) => {
  const orderStatusLabel = useOrderStatusLabel(tradeStatus ?? 'WAITING_PAY');
  if (tradeStatus === 'TRADE_SUCCESS') {
    return (
      <span className="text-[#00BF69] bg-[#EBFAF3] px-1 py-0.5 rounded-sm">{orderStatusLabel}</span>
    );
  }
  if (tradeStatus === 'CANCEL') {
    return (
      <span className="text-[#FF433D] bg-[#FFF0F0] px-1 py-0.5 rounded-sm">{orderStatusLabel}</span>
    );
  }
  return (
    <span className="text-[#336FFF] bg-[#F0F7FF] px-1 py-0.5 rounded-sm">{orderStatusLabel}</span>
  );
};
